import { FC, HtmlHTMLAttributes, useState } from 'react';
import { Box, Flex, Stack } from 'flicket-ui';
import { Icon } from '~components/common';

const RoundButton: FC<Omit<HtmlHTMLAttributes<HTMLDivElement>, 'color'>> = ({
  children,
  ...props
}) => (
  <Flex
    cursor="pointer"
    height={34}
    width={34}
    variant="center"
    backgroundColor="N200"
    borderRadius={'50%' as any}
    {...props}
  >
    {children}
  </Flex>
);

export const ImageSlider = (props: { images: string[] }) => {
  const [currentIndex, setIndex] = useState(0);
  const { images } = props;
  return (
    <Box>
      <Box
        borderRadius="sm"
        width="100%"
        pt={'100%' as any}
        borderWidth={1 as any}
        borderStyle="solid"
        borderColor="N200"
        backgroundImage={`url(${images[currentIndex]})`}
        backgroundPosition="center"
        backgroundSize="cover"
      />
      <Flex mt={3} alignItems="center" justifyContent="space-between">
        <RoundButton
          onClick={() =>
            setIndex((i) => (currentIndex ? i - 1 : images.length - 1))
          }
        >
          <Icon fontSize={6} icon="chevron-left" />
        </RoundButton>
        <Stack space={12}>
          {images
            .slice(
              ...(() => {
                switch (true) {
                  case currentIndex < 2:
                    return [0, 3];
                  case currentIndex > images.length - 2:
                    return [images.length - 3, images.length];
                  default:
                    return [currentIndex - 1, currentIndex + 2];
                }
              })(),
            )
            .map((image, i) => {
              const originalIndex = images.findIndex((i) => i === image);
              return (
                <Box
                  key={i}
                  height={80}
                  width={80}
                  backgroundImage={`url(${image})`}
                  backgroundPosition="center"
                  backgroundSize="cover"
                  borderWidth={1 as any}
                  borderStyle="solid"
                  borderColor={originalIndex === currentIndex ? 'P300' : 'N200'}
                  borderRadius="sm"
                  onClick={() => setIndex(originalIndex)}
                  cursor="pointer"
                />
              );
            })}
        </Stack>

        <RoundButton
          onClick={() =>
            setIndex((i) => (currentIndex === images.length - 1 ? 0 : i + 1))
          }
        >
          <Icon fontSize={6} icon="chevron-right" />
        </RoundButton>
      </Flex>
    </Box>
  );
};
